import { toast } from "react-toastify";
import { apiSlice } from ".";

const RolesApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getRoles: builder.query({
      query: () => `/RoleTables/GetRoleTables`,
    }),
    getAllRolesForTable: builder.query({
      query: ({ agcId }) => `/TableRights/GetTablebyRightsbyAgencyid?agencyid=${agcId}`,
    }),
    getAllLeadsRolesForTable: builder.query({
      query: ({ agcId }) => `/LeadPermissions/GetLeadPermissions?agencyid=${agcId}`,
    }),
    postRole: builder.mutation({
      query: (data) => ({
        url: "/TableRights/PostTableRight",
        method: "POST",
        body: data,
      }),
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        toast.promise(queryFulfilled, {
          pending: "Assigning Role",
          success: "Role Has Been Assign",
          error: "Error Assigning Role",
        });
      },
    }),
    postLeadsPermissions: builder.mutation({
      query: (data) => ({
        url: "/LeadPermissions/PostLeadPermissions",
        method: "POST",
        body: data,
      }),
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        toast.promise(queryFulfilled, {
          pending: "Assigning Leads Permissions",
          success: "Permissions Has Been Assign",
          error: "Error Assigning Permissions",
        });
      },
    }),
    updateRole: builder.mutation({
      query: ({ id, data }) => ({
        url: `/TableRights/UpdateRightsTable/${id}`,
        method: "POST",
        body: data,
      }),
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        toast.promise(queryFulfilled, {
          pending: "Updating Role",
          success: "Role Has Been Updated",
          error: "Error Updating Role",
        });
      },
    }),
  }),
});

export const {
  useGetRolesQuery,
  usePostRoleMutation,
  useUpdateRoleMutation,
  useGetAllRolesForTableQuery,
  usePostLeadsPermissionsMutation,
  useGetAllLeadsRolesForTableQuery
} = RolesApi;
